import "./accessCard.css";
import logo from "../../../assets/images/tigo-money-azul.png";
import selectCountryPa from "../../../assets/images/panama-round.png";
import HamburguerButton from "../../../assets/images/hambuguer-acces.png";
import Android from "../../../assets/images/android-access-card.png";
import Ios from "../../../assets/images/ios-access-card.png";
import MainImage from "../../../assets/images/main-mast-access-card.png";
import ImageWaterfall from "../../../assets/images/image-waterfall.png";
import imageCorp from "../../../assets/images/visa-logo.png";
import MainImagSec2  from "../../../assets/images/main-img-sec-2.png"
import MainImagSec3  from "../../../assets/images/main-img-sec-3.png"
import ImgSec31 from "../../../assets/images/item-sec-31.png"
import ImgSec32 from "../../../assets/images/item-sec-32.png"
import ImgSec33 from "../../../assets/images/item-sec-33.png"
import RowAccordion from "../../../assets/images/row-accordion.png"
import LogoFooter from "../../../assets/images/logo-footer-ac.png"
import VisaFooter from "../../../assets/images/visa-footer.png"
import LinkedInFooter from "../../../assets/images/linkedin-footer.png"
import FacebookFooter from "../../../assets/images/facebook-footer.png"
import InstaFooter from "../../../assets/images/instagram-footer.png"
import Thumb01 from "../../../assets/images/thumb-ac-01.png";
import Thumb02 from "../../../assets/images/thumb-ac-02.png";
import Thumb03 from "../../../assets/images/thumb-ac-03.png";
import ScrollGIF from "../../../assets/images/scroll-down.gif";
import Loading from "../../base/loading/loading";
import { useLocation, Link } from "react-router-dom";
import React, {useEffect, useState} from "react";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Helmet } from "react-helmet";
import Header from "../../base/header/header";
import TopMenu from "../../base/topMenu/topMenu";
import Footer from "../../base/footer/footer";
import DownloadApp from "../../base/downloadApp/downloadApp"
import {justURLString, OnLinkClick, validatePath} from "../../../utils/generals"



const queryTmp  = `
  {
    accessCardCollection (where: {seoMetadata: {path:  "&slug&"}}) {
      items{
        internalName
          pageTitle
          slug
          seoMetadata{
              description
              hreflang
              href
              canonicalHref
          }
        nav{
           logo {
            url
          }
          menuItems 
          
        }
        mainText
        appButton {
          title
          downloadButtons
        }
        mainImage {
          url
          description
        }
        servicesTiles
        titleSection2
        itemsSection2
        titleSection3
        textSection3
        imageBranSection3 {
          url
        }
        itemsSection3
        titleSection4 {
          json
        }
        imageSection3{
          url
        }
        imageSection4
        faqTitle {
          json
        } 
        faqAccordion
        footerGray {
          brandImage1 {
            url
          }
          brandImage2 {
            url
          }
          subMenuFooter
          legalsFooter
          socialMedia
          copyRight
          titleFooter
          textFooter
        }
        
        
      }
    }
  }`;



// const queryTmp  = `
//   {
//     accessCardCollection (where: {slug: "&slug&"}) {
//       items{
//         internalName
//           pageTitle
//           slug
//           seoMetadata{
//               description
//               hreflang
//               href
//               canonicalHref
//           }
//         nav{
//            logo {
//             url
//           }
//           menuItems 
          
//         }
//         mainText
//         appButton {
//           title
//           downloadButtons
//         }
//         mainImage {
//           url
//           description
//         }
//         servicesTiles
//         titleSection2
//         itemsSection2
//         titleSection3
//         textSection3
//         imageBranSection3 {
//           url
//         }
//         itemsSection3
//         titleSection4 {
//           json
//         }
//         imageSection3{
//           url
//         }
//         imageSection4
//         faqTitle {
//           json
//         } 
//         faqAccordion
//         footerGray {
//           brandImage1 {
//             url
//           }
//           brandImage2 {
//             url
//           }
//           subMenuFooter
//           legalsFooter
//           socialMedia
//           copyRight
//           titleFooter
//           textFooter
//         }
        
        
//       }
//     }
//   }`;


  

const AccessCard = () => {

  const location = useLocation();
  const [page, setPage] = useState(false);

  

  useEffect(()=> {

    const query = queryTmp.replace("&slug&", validatePath(location.pathname));   

      window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authenticate the request
          Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
        },
        // send the GraphQL query
        body: JSON.stringify({ query }),
      })
      .then((response) => response.json())

      .then(({ data, errors }) => {
        
        if (errors) {
          console.log(errors);
        }

        // console.log('data', data);

        data.accessCardCollection.items[0].currentURL = justURLString();
        setPage(data.accessCardCollection.items[0])
      });




  }, [])

  // show a loading screen case the data hasn't arrived yet
  if (!page) {
    return(<Loading />)
  }  

  return (
    <div className="access-card-container  ">
      <TopMenu  urlAccount={page.urlAccount}/>
      <Helmet htmlAttributes={{ lang : page.seoMetadata.hreflang }}>
        <meta charSet="utf-8" />
        <title>{page.pageTitle}</title>
        <meta name="description" content={page.seoMetadata.description}></meta>
        <meta name="keywords" content={page.seoMetadata.keywords}></meta>
        <link
          rel="alternate"
          hreflang={page.seoMetadata.hreflang}
          href={page.seoMetadata.href}
        />
        <link rel="canonical" href={page.canonicalHref} />
      </Helmet>
      <Header logo={page.nav.logo} menuItems={page.nav.menuItems.menu} />
      {/* <div className="header-access-card container-fluid  p-0  ">
        <div className="container h-100   ">
          <div className="row  h-100 ">
            <div className="col-6 col-sm-6 col-md-2  d-flex align-items-center h-100">
              <img className="col-md-11 col-7" src={page.nav.logo.url} alt="main logo" />
            </div>
            <div className="col-md-7  p-0 d-none d-sm-block d-sm-none d-md-block">
              <div className="h-100 ">
                <div className="d-flex h-100  align-items-center justify-content-end gap-4 ">
                  {page.nav.menuItems.menu.map((item, index)=> {
                      return(
                        <div className="access-card-item">
                          {" "}
                          <a href={item.url} >{item.label}</a>
                        </div>
                      )

                  })}
                </div>
              </div>
            </div>
            <div className=" col-6 col-sm-6 col-md-3 ">
              <div className="h-100 d-flex justify-content-between  align-items-center ">
                <div className="col-md-6 col-8 cta-ac-container ms-3">
                  <a href={page.nav.menuItems.rightSideData.cta.url_button} target="_blank" rel="noreferrer">
                    <div className="my-card col-12 ">{page.nav.menuItems.rightSideData.cta.label_button}</div>    
                  </a>
                  
                </div>
                <div>
                  <img
                    className=" d-md-none d-lg-block d-lg-none d-xl-block d-xl-none"
                    src={HamburguerButton}
                    alt="hamburguer"
                  />
                  <a href={page.nav.menuItems.rightSideData.selectCountry.url_country}>
                    <img
                      className="col-8 d-none d-sm-block d-sm-none d-md-block"
                      src={page.nav.menuItems.rightSideData.selectCountry.image_country}
                      alt="panama"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* main */}
      <div className="access-card-main-content  ">
        <div className="container h-100">
          <div className="row   h-100 p-0">
            <div className="col-md-7    p-0 height-main-ac" style={{position: 'relative'}} >
              {/* <div className=" h-50    col-12 "> */}
              <div className="     col-12 ">
                <p className="main-text-access-card p-4 p-md-0  " dangerouslySetInnerHTML={ {__html:page.mainText}}>
                  {/* Obtén tu Tigo Money y conoce la forma más <br /> fácil de{" "}
                  <b>manejar tu dinero</b> */}
                </p>
                {/* <div className="label-gray-ac d-none d-sm-block d-sm-none d-md-block">{page.appButton.title}</div> */}
                <div className="col-4 mt-4 d-none d-sm-block d-sm-none d-md-block ">
                  {/* <a href={page.appButton.downloadButtons.items[0].cta} target="_blank" rel="noreferrer"> */}
                    <button onClick={()=>OnLinkClick(page.appButton.downloadButtons.items[0].cta, page.currentURL)} className="download-main-btn">Descargar</button>
                  {/* </a> */}
                  
                  {/* <div className="row">
                    <div className="col-6">
                      { page.appButton.downloadButtons.items[0] &&
                          <a href={page.appButton.downloadButtons.items[0].cta} target="_blank" rel="noreferrer">
                          <img
                            className="img img-fluid"
                            src={page.appButton.downloadButtons.items[0].image}
                            alt="ios"
                          />
                        </a>
                      }
                    </div>
                    <div className="col-6">
                        { page.appButton.downloadButtons.items[1] &&
                          <a href={page.appButton.downloadButtons.items[1].cta} target="_blank" rel="noreferrer">
                            <img className="img img-fluid" 
                            src={page.appButton.downloadButtons.items[1].image}
                            alt="android" />
                          </a>
                        }
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="col-1 p-3  d-none d-md-block   " style={{position: 'absolute', bottom:0, right: 10, height: '6em'}}>
                <img className="h-100" src={ScrollGIF} alt="gif-scroll" style={{marginLeft: '-3em'}}/>
              </div>
            </div>
            <div className="col-md-5  d-flex  align-items-md-center p-0 ">
              <div className="h-75   mt-md-5  mast-ac-container">
                <div className="h-100 w-100 ps-5 pe-5 pb-5 p-md-2  d-flex justify-content-center  align-items-md-center">
                  {/* <img src={MainImage} alt="main" style={{height: 'auto', width: "100%"}} /> */}
                  <a  href={page.mainImage.description} target="_blank" rel="noreferrer">
                    <img src={page.mainImage.url} alt="main" className="img img-fluid " />
                  </a>
                </div>
                
                {/* <div className="hostpot-1 d-none d-md-block ">
                  <a href={page.servicesTiles.items[0].button_url}>
                    <div className="bg-hostpot  p-2  d-flex justify-content-center align-items-md-center">
                      <img src={page.servicesTiles.items[0].icon_url} className="col-4" alt="thumb-1"/> 
                    </div>
                    <div className="label-hostpot">{page.servicesTiles.items[0].title}</div>
                  </a>
                </div>
                <div className="hostpot-2 d-none d-md-block">
                    <a href={page.servicesTiles.items[1].button_url}>
                        <div className="bg-hostpot  d-flex justify-content-center align-items-md-center">
                          <img src={page.servicesTiles.items[1].icon_url} className="col-4" alt="thumb-1"/> 
                        </div>
                        <div className="label-hostpot">{page.servicesTiles.items[1].title}</div>
                    </a>
                </div>
                <div className="hostpot-3 d-none d-md-block">
                    <a href={page.servicesTiles.items[2].button_url}>
                        <div className="bg-hostpot  d-flex justify-content-center align-items-md-center">
                          <img src={page.servicesTiles.items[2].icon_url} className="col-4" alt="thumb-1"/> 
                        </div>
                        <div className="label-hostpot">{page.servicesTiles.items[2].title}</div>
                    </a>
                </div> */}
              </div>
            </div>
          </div>
          
          <div className="app-button-mobile-ac pb-3 d-md-none d-lg-block d-lg-none d-xl-block d-xl-none text-center pb-5 mt-1 ">

            {/* <div className="label-gray-ac d-flex justify-content-center " dangerouslySetInnerHTML={{__html:page.appButton.title }} ></div>
            <div className="col-12 mt-1    ">
                <div className="row h-100 d-flex justify-content-center">
                  <div className="col-4">

                    { page.appButton.downloadButtons.items[0] && 
                      <a href={page.appButton.downloadButtons.items[0].cta} target="_blank" rel="noreferrer">
                        <img
                          className="img img-fluid"
                          src={page.appButton.downloadButtons.items[0].image}
                          alt="android"
                        />
                      </a>}
                      
                  </div>
                  <div className="col-4">
                    { page.appButton.downloadButtons.items[1] &&
                      
                      <a href={page.appButton.downloadButtons.items[1].cta} target="_blank" rel="noreferrer">
                        <img className="img img-fluid" src={page.appButton.downloadButtons.items[1].image} alt="ios" /> 
                      </a>
                    }
                  </div>
                </div>
              </div> */}

                <a href={page.appButton.downloadButtons.items[0].cta} target="_blank" rel="noreferrer">
                    <button className="download-main-btn">Descargar</button>
                  </a>

          </div>
          
        </div>
      </div>

      <div className="section-01-container  d-flex justify-content-center align-items-center">
        <div className=" h-75 container p-0">
          <p className="title-2-ac col-md-6 col-10 p-4 mt-5 p-md-0 " dangerouslySetInnerHTML={{__html: page.titleSection2}}>
            {/* Simplifica tus transacciones y <br />
            <b>toma el control total de tus finanzas</b> */}
          </p>

          <div className="waterfall-items-container mt-5  col-12">
            <div className="row   gap-md-3  justify-content-center">
              <div className=" item-waterfall  ">
                <div className="waterfall-contet  col-12 ">
                  <div className=" d-flex justify-content-center  pt-3 pb-2">
                    <a href={page.itemsSection2.items[0].url}>
                      <img src={page.itemsSection2.items[0].icon_url} alt="item-waterfall" />
                    </a>
                  </div>
                  <div className="w-100  text-center waterfall-title" dangerouslySetInnerHTML={{__html:page.itemsSection2.items[0].title}}>
                    {/* {page.itemsSection2.items[0].title} */}
                  </div>
                  <div className="waterfall-text " dangerouslySetInnerHTML={{__html:page.itemsSection2.items[0].text}}>
                  {/* {page.itemsSection2.items[0].text} */}
                  </div>
                </div>
              </div>
              <div className="item-waterfall " style={{ marginTop: "5%" }}>
                  <div className=" d-flex justify-content-center pt-3 pb-2">
                    <a href={page.itemsSection2.items[1].url}>
                      <img src={page.itemsSection2.items[1].icon_url} alt="item-waterfall" />
                    </a>
                  </div>
                  <div className="w-100  text-center waterfall-title" dangerouslySetInnerHTML={{__html:page.itemsSection2.items[1].title}} >
                    {/* {page.itemsSection2.items[1].title} */}
                  </div>
                  <div className="waterfall-text " dangerouslySetInnerHTML={{__html:page.itemsSection2.items[1].text}}>
                  {/* {page.itemsSection2.items[1].text} */}
                  </div>
              </div>
              <div className="item-waterfall last-waterfall" >
                  <div className=" d-flex justify-content-center pt-3 pb-2">
                    <a href={page.itemsSection2.items[2].url}>
                      <img src={page.itemsSection2.items[2].icon_url} alt="item-waterfall" />
                    </a>
                  </div>
                  <div className="w-100  text-center waterfall-title" dangerouslySetInnerHTML={{__html:page.itemsSection2.items[2].title}}>
                    {/* {page.itemsSection2.items[2].title} */}
                  </div>
                  <div className="waterfall-text " dangerouslySetInnerHTML={{__html:page.itemsSection2.items[2].text}}>
                    {/* {page.itemsSection2.items[2].text} */}
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-02-container ">
        <div className="container h-100 ">
          <div className="access-h2  w-100 text-center pt-4" dangerouslySetInnerHTML={{__html: page.titleSection3}}>
          </div>
          <div className=" d-flex justify-content-center pb-4">
              <div className="col-8 col-md-4  text-center">
                <span>{page.textSection3} </span> <span>
                  <img src={page.imageBranSection3.url} alt=""/>
                </span>
              </div>
          </div>
          <div className="  height-row-sec-02 mt-4  ">
              <div className="row h-100 ">
                <div className="order-2 order-md-1 col-md-4 h-100 item-sec-2-container pt-4 ">
                  <div className="item-sec-2-top p-3   ">
                      <div className="bg-item-sec-2 p-4">

                        <div className="square-sec-02 p-3">
                            <img className="img-fluid" src={page.itemsSection3.items[0].image} alt="thumb"/>
                        </div>
                        <div className="title-item-sec-2 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[0].title}}>
                          {/* {page.itemsSection3.items[0].title} */}
                        </div>

                        <div className="des-sec-02 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[0].text}}>
                        {/* {page.itemsSection3.items[0].text} */}
                        </div>


                      </div>
                  </div>
                  <div className="item-sec-2-bottom  p-3" >
                    <div className="bg-item-sec-2 p-4">
                        <div className="square-sec-02 p-3">
                          <img className="img-fluid" src={page.itemsSection3.items[1].image} alt="thumb"/>
                        </div>
                        <div className="title-item-sec-2 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[1].title}}>
                          {/* {page.itemsSection3.items[1].title} */}
                        </div>

                        <div className="des-sec-02 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[1].text}}>
                          {/* {page.itemsSection3.items[1].text} */}
                        </div>
                    </div>
                  </div>
                </div>


                <div className="order-1 order-md-2 col-md-4 p-md-2    middle-sec-2 item-sec-2-container">
                    <div className="w-100 title-item-sec-2  pt-md-4 p-2 pt-3 ms-1 " dangerouslySetInnerHTML={{__html:page.itemsSection3.items[2].title}}>
                      {/* {page.itemsSection3.items[2].title} */}
                    </div>
                    <div className="des-sec-02 pt-md-2  ms-2 " dangerouslySetInnerHTML={{__html:page.itemsSection3.items[2].text}}>
                      {/* {page.itemsSection3.items[2].text} */}
                    </div>

                    {/* <div className=" h-75 w-100 pt-1   d-flex align-items-end justify-content-center item-sec-2-bottom-03 debug ">
                        <img className="col-10 col-md-9 debug" src={page.itemsSection3.items[2].image} alt="imagen warrio" />
                    </div> */}

                    <div className=" h-md-75 w-md-100 pt-3 d-flex align-items-md-end justify-content-center item-sec-2-bottom-03 ">
                        <img className="col-10 col-md-9 " src={page.itemsSection3.items[2].image} alt="imagen warrio" />
                    </div>

                </div>


                <div className="order-3 order-md-3 col-md-4   item-sec-2-container"> 

                    <div className="item-sec-2-top p-3 ">
                        <div className="bg-item-sec-2 p-4">
                          <div className="square-sec-02 p-3">
                            <img className="img-fluid" src={page.itemsSection3.items[3].image} alt="thumb"/>
                          </div>
                          <div className="title-item-sec-2 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[3].title}}>
                            {/* {page.itemsSection3.items[3].title} */}
                          </div>

                          <div className="des-sec-02 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[3].text}}>
                            {/* {page.itemsSection3.items[3].text} */}
                          </div>
                        </div>
                    </div>
                    <div className="item-sec-2-bottom  p-3">
                      <div className="bg-item-sec-2 p-4">
                          <div className="square-sec-02 p-3">
                            <img className="img-fluid" src={page.itemsSection3.items[4].image} alt="thumb"/>
                          </div>
                          <div className="title-item-sec-2 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[4].title}}>
                            {/* {page.itemsSection3.items[4].title} */}
                          </div>

                          <div className="des-sec-02 pt-2" dangerouslySetInnerHTML={{__html:page.itemsSection3.items[4].text}}>
                            {/* {page.itemsSection3.items[4].text} */}
                          </div>
                      </div>
                    </div>

                </div>
              </div>
          </div>
        </div>
      </div>

      <div className="section-03-container ">
        <div className="container h-100 ">
            <div className="row  h-100">
                <div className="col-md-6  order-2 order-md-1 d-flex align-items-md-center align-items-start img-sec-3-container">
                      <img className="img-sec-3 " src={page.imageSection3.url} alt=""/>
                </div>
                <div className="col-md-6 order-1 order-md-2 content-height-sec-3  d-flex align-items-md-end align-items-start justify-content-center ">
                    <div className=" h-50  p-3">
                      {/* <div className="access-h2 ">
                        3 pasos para obtener tu tarjeta Tigo Money:
                      </div> 
                      <div className="label-gray-ac mt-1">
                        Será tuya en menos de 5 minutos
                      </div>  */}
                      <div className="access-h2 h1">
                        {documentToReactComponents(page.titleSection4.json)}
                      </div>

                      <div className="mt-2">
                          
                          { page.imageSection4.items[0] &&

                              <div className="item-sec-3 d-flex justify-content-start">
                                <div className="img-item-sec3 p-2 col-3 ">
                                  <img className="img-fluid" src={page.imageSection4.items[0].icon_url} alt=""/>
                                </div>
                                <div className="ms-2 col-10">
                                  <a href={page.imageSection4.items[0].url} dangerouslySetInnerHTML={{__html:page.imageSection4.items[0].text}}>
                                    {/* {page.imageSection4.items[0].text} */}
                                  </a>
                                </div>
                              </div>

                          }
                          { page.imageSection4.items[1] &&

                            <div className="item-sec-3 d-flex justify-content-start mt-2 ">
                              <div className="img-item-sec3 p-2 col-3">
                                <img className="img-fluid" src={page.imageSection4.items[1].icon_url} alt=""/>
                              </div>
                              <div className="ms-2 col-10 ">
                                <a href={page.imageSection4.items[1].url} dangerouslySetInnerHTML={{__html:page.imageSection4.items[1].text}}>
                                  {/* {page.imageSection4.items[1].text} */}
                                </a>
                              </div>
                            </div>

                          }
                          { page.imageSection4.items[2] &&

                            <div className="item-sec-3 d-flex justify-content-start mt-2 ">
                              <div className="img-item-sec3 col-3 p-2  ">
                                <img className="img-fluid" src={page.imageSection4.items[2].icon_url} alt=""/>
                              </div>
                              <div className="ms-2  col-10">
                                <a href={page.imageSection4.items[2].url} dangerouslySetInnerHTML={{__html:page.imageSection4.items[2].text}}>
                              
                                </a>
                              </div>
                            </div>
                          }
                      </div>
                    </div>
                </div>

            </div>
        </div>

      </div>

      <div className="section-04-container pt-4 pb-4 d-flex  align-items-center ">

        <div className=" container h-75 sec-04-main p-4">
            <div className="access-h2 h1 ms-4">
              {documentToReactComponents(page.faqTitle.json)}
            </div>

            <div className="accordion-home p-4">
              {/* <div className="accordion-item d-flex  align-items-center   p-3">
                <div className="row w-100">
                  <div className="col-11  title-accordion">
                    ¿Puedo tener Tigo Money si mi compañía telefónica no es Tigo?
                  </div>
                  <div className="col-1">
                    <img className="col-4"  src={RowAccordion} alt=""/>
                  </div>
                </div>
              </div>
              <div className="accordion-item d-flex  align-items-center  p-3">
                <div className="row w-100">
                  <div className="col-11  title-accordion">
                    ¿Qué es un Punto Tigo Money?
                  </div>
                  <div className="col-1">
                    <img className="col-4" src={RowAccordion} alt=""/>
                  </div>
                </div>
              </div>
              <div className="accordion-item d-flex  align-items-center  p-3">
                <div className="row w-100">
                  <div className="col-11  title-accordion">
                    ¿Puedo pagar con Tigo Money mis facturas?
                  </div>
                  <div className="col-1">
                    <img className="col-4" src={RowAccordion} alt=""/>
                  </div>
                </div>
              </div>
              <div className="accordion-item d-flex  align-items-center  p-3">
                <div className="row w-100">
                  <div className="col-11  title-accordion">
                    ¿Puedo pagar con Tigo Money mis facturas?
                  </div>
                  <div className="col-1">
                    <img className="col-4" src={RowAccordion} alt=""/>
                  </div>
                </div>
              </div>
              <div className="accordion-item d-flex  align-items-center  p-3">
                <div className="row w-100">
                  <div className="col-11  title-accordion">
                    ¿Puedo pagar con Tigo Money mis facturas?
                  </div>
                  <div className="col-1">
                    <img className="col-4" src={RowAccordion} alt=""/>
                  </div>
                </div>
              </div> */}

              <div className="accordion" id="accordionExample">
                {page.faqAccordion.items.map((faq, i)=> {
                  return (
                    // <div className="accordion-item">
                    //   <h2 className="accordion-header title-accordion" id={"heading"+i}>
                    //     <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse"+i} aria-expanded="false" aria-controls={"collapse"+i}>
                    //       {faq.title}
                    //     </button>
                    //   </h2>
                    //   <div id={"collapse"+i} className="accordion-collapse collapse show" aria-labelledby={"heading"+i} data-bs-parent="#accordionExample">
                    //     <div className="accordion-body" dangerouslySetInnerHTML={{__html: faq.text}}>
                    //       {/* <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow. */}
                    //     </div>
                    //   </div>
                    // </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header " id={"heading"+i}>
                        <button className="accordion-button collapsed title-accordion " type="button" data-bs-toggle="collapse" data-bs-target={"#collapse"+i} aria-expanded="false" aria-controls={"collapse"+i}>
                          {faq.title}
                        </button>
                      </h2>
                      <div id={"collapse"+i} className="accordion-collapse collapse" aria-labelledby={"heading"+i} data-bs-parent="#accordionExample">
                        <div className="accordion-body text-faq" dangerouslySetInnerHTML={{__html: faq.text}}>
                          {/* <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow. */}
                        </div>
                      </div>
                    </div>
                  )
                })}
                {/* <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Accordion Item #2
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Accordion Item #3
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                    </div>
                  </div>
                </div> */}
              </div>
             
            </div> 

        </div>
          


      </div>

      {/* <div className="access-card-footer">

          <div className="container h-100 pt-4 pb-4">
            <hr className="hr-access" />


            <div className="row h-75  p-4">

              <div className="col-md-6">
                  <div className="d-flex row">
                    <img className="col-3" src={page.footerGray.brandImage1.url} alt=""/>
                    <img className="col-2 ms-4" src={page.footerGray.brandImage2.url} alt=""/>
                  </div>
                  <div className="row  pt-4 link-footer">
                      <div className="col-md-6 ">
                        {page.footerGray.subMenuFooter.menu_items.map((item, index)=> {

                           return(<div className="w-100 pt-2 link-footer-a">
                           <a href={item.url}>
                              {item.label}
                           </a>
                         </div>) 

                        })}
                      </div>
                      <div className="col-md-6 ">
                          {
                            page.footerGray.legalsFooter.menu_items.map((item, i)=> {
                              return(<div className="w-100 pt-2 legals-ac-item">
                                      <a href={item.url}>
                                        <b>{item.label}</b>
                                      </a>
                                      </div>)
                            })
                          }
                          <div className="w-100">
                            <div className="row mt-4">
                                  {page.footerGray.socialMedia.menu_items.map((item, i)=> {
                                      return (
                                        <a className="col-2" href={item.url} target="_blank" rel="noreferrer">
                                          <img className="col-12" src={item.image} alt=""/>
                                        </a>
                                      )
                                  })}
                            </div>
                          </div>  
                      </div>
                  </div>
              </div>
              

              <div className="col-md-6  p-4">
                <div className="w-100 h-100 right-footer-ac d-flex align-items-center">
                  <div className="h-75  w-100 p-2 ">
                      <div className="col-12 footer-ac-label">
                        {page.footerGray.titleFooter}
                      </div>
                      <div className="footer-ac-text">
                        {page.footerGray.textFooter}
                      </div>
                      <div className="row w-50 pt-2">
                        <div className="col-6">
                          <a href={page.appButton.downloadButtons.items[0].cta} target="_blank" rel="noreferrer">
                            <img
                              className="img img-fluid"
                              src={page.appButton.downloadButtons.items[0].image}
                              alt="ios"
                            />
                          </a>
                        </div>
                        <div className="col-6">
                          <a href={page.appButton.downloadButtons.items[1].cta} target="_blank" rel="noreferrer">
                            <img
                              className="img img-fluid"
                              src={page.appButton.downloadButtons.items[1].image}
                              alt="android"
                            />
                          </a>
                        </div>
                      </div>
                  </div>
                </div>
              </div>

            </div>

            <hr className="hr-access" />
              <span className="copyrights">{page.footerGray.copyRight}</span>
          </div>


      </div> */}

    <div className="container-fluid footer-container">
      <Footer data={page.footerGray} />
    </div>

    <div className=" p-1 container-fluid  tyc-container d-flex justify-content-center">
          <Link to={"/legales?id=homePageCollection&slug=home-"+"pa"}>
            Términos y Condiciones
          </Link>
    </div>
      
    </div>
  );
};

export default AccessCard;
